import { IOption } from '@/types'

export const colors: IOption<string>[] = [
  {
    label: 'beige',
    value: 'Beige',
  },
  {
    label: 'black',
    value: 'Black',
  },
  {
    label: 'blue',
    value: 'Blue',
  },
  {
    label: 'brown',
    value: 'Brown',
  },
  {
    label: 'champagne',
    value: 'Champagne',
  },
  {
    label: 'coffee',
    value: 'Coffee',
  },
  {
    label: 'green',
    value: 'Green',
  },
  {
    label: 'grey',
    value: 'Grey',
  },
  {
    label: 'hazil',
    value: 'Hazil',
  },
  {
    label: 'l_green',
    value: 'L.Green',
  },
  {
    label: 'orange',
    value: 'Orange',
  },
  {
    label: 'purple',
    value: 'Purple',
  },
  {
    label: 'red',
    value: 'Red',
  },
  {
    label: 'silver',
    value: 'Silver',
  },
  {
    label: 'tchele',
    value: 'Tchele',
  },
  {
    label: 'turquoise',
    value: 'Turquoise',
  },
  {
    label: 'white',
    value: 'White',
  },
]

export enum SelectedType {
  Driver = 'driver',
  Customer = 'customer',
}
